import { ContactProspectDetail } from "../schema/contact-detail";

/**
 * Pick the list-person id that drives a lead's Chat view from a resolved prospect
 * detail. A prospect can belong to several lists; we use the **most recent**
 * membership — the highest `listPersonId`, since ids are autoincrement and
 * `sourceContexts` carries no timestamp. Returns `undefined` when the prospect is
 * on no list (the Chat view is then not offered).
 */
export const resolveChatListPersonId = (
	detail: ContactProspectDetail | null | undefined
): number | undefined => {
	const ids = (detail?.sourceContexts ?? [])
		.map((context) => context.listPersonId)
		.filter((id): id is number => typeof id === "number");

	return ids.length > 0 ? Math.max(...ids) : undefined;
};
